<div class="dialog-container">
  <h2 mat-dialog-title>{{ isEdit ? 'Edit Character' : 'Add new Character' }}</h2>
  
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <mat-dialog-content>
      <div class="form-fields">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Character Tag</mat-label>
          <input matInput formControlName="tag" [placeholder]="'e.g. \'' + placeholder.tag + '\''" (input)="onTagInput($event)">
          <mat-hint>This is how you will refer to the character in the script</mat-hint>
          <mat-error *ngIf="form.get('tag')?.hasError('required')">
            Character tag is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Character Name</mat-label>
          <input matInput formControlName="name" [placeholder]="'e.g. \'' + placeholder.name + '\''" maxlength="30">
          <span matTextSuffix [style.color]="form.get('name')?.value?.length > 20 ? 'orange' : 'inherit'">
            {{form.get('name')?.value?.length || 0}} /30
          </span>
          <mat-hint>This label will appear in-game</mat-hint>
          <mat-error *ngIf="form.get('name')?.hasError('required')">
            Character name is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Starting Location</mat-label>
          <mat-select formControlName="location" placeholder="Select One">
            @for (location of availableLocations; track location.id) {
              <mat-option [value]="location">
                {{ location.name }}
              </mat-option>
            }
          </mat-select>
          <mat-hint>Where the character gets teleported to at the start of the script</mat-hint>
          <mat-error *ngIf="form.get('location')?.hasError('required')">
            Please select a starting location
          </mat-error>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      @if (isEdit) {
        <button mat-button type="button" color="warn" (click)="onDelete()">Delete</button>
      }
      <button mat-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button  type="submit" [disabled]="!form.valid">
        {{ isEdit ? 'Apply Changes' : 'Add Character' }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
